import React, {PureComponent} from 'react'
import {Route, Switch} from 'react-router-dom'
import Sales from './containers/Sales'
import CashDesk from './containers/CashDesk'
import TicketSales from './containers/TicketSales'
import TicketCashDesks from './containers/TicketCashDesks'
import TicketGratis from './containers/TicketGratis'
import TicketDetail from './containers/TicketDetail'
import TicketCashDeskDetail from './containers/TicketCashDeskDetail'
import TicketCanceled from './containers/TicketCanceled'

export default class Index extends PureComponent {
  render() {
    return (
      <Switch>
        <Route exact path="/sales" component={Sales} />
        <Route exact path="/cashdesk" component={CashDesk} />
        <Route exact path="/tickets" component={TicketSales} />
        <Route exact path="/ticketCashDesk" component={TicketCashDesks} />
        <Route exact path="/ticketGratis" component={TicketGratis} />
        <Route exact path="/ticketCanceled" component={TicketCanceled} />
        <Route exact path="/tickets/:id" render={(props) => <TicketDetail {...props}/>} />
        <Route exact path="/ticketCashDesk/:id" render={(props) => <TicketCashDeskDetail {...props}/>} />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Reports/index.tsx